import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';


const FileListsModal = ({ files }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return(<>
    <Button onClick={ handleShow } variant='outline-dark' size='sm' className='mb-2 mb-md-0 white-space-nowrap'>
      <i className='icon icon-docs'></i> { gettext('Список файлов') }
    </Button>
    <Modal show={ show } onHide={ handleClose } size='md'>
      <Modal.Header closeButton>
        <Modal.Title>
          { gettext('Список файлов') }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        { files }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={ handleClose }>
          { gettext('Закрыть') }
        </Button>
      </Modal.Footer>
    </Modal>
  </>)
}

FileListsModal.propTypes = {
  files: PropTypes.array.isRequired
}


export default compose(
  connect(null, {}),
)(FileListsModal);
